import React from 'react';
import { Navigate } from 'react-router-dom';
import { useReadyTranslation } from '../hooks/useReadyTranslation';
import { useAuth } from '../contexts/AuthContext';
import CuadroDeOpinion from '../components/CuadroDeOpinion';
import { EncabezadoDePagina } from '../components/alumno';
import { ESTADO_DEL_REBOTE } from '../lib/razonDelRegistro';

/* Remate de post-t7-2c (R1, "1. si" de Carlos del 15-oct): LA PANTALLA "GANA CREDITOS GRATIS" (/earn-credits).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   El titulo es el MISMO par del renglon del menu lateral (`common:nav.earn_credits`) y debajo va UNA tarjeta: el
   cuadro de opinion (`components/CuadroDeOpinion.js`, que pide su estado y pinta sus caras).
   Se monta como /settings en App.js (ExamLockedRoute dentro de ProtectedRoute, en la web y en la app); el invitado
   rebota a /signup por el MISMO camino que Ajustes (la pantalla lo hace, sin preguntar nada). Nada web dentro: la
   app la pinta igual.

   pantallas-alumno (G): el encabezado de pagina de la casa (34, 26 en el celular; sin texto debajo, como hoy) y el
   contenido hasta 720, centrado. P12 de la parte 2: el rebote del invitado lleva la razon en el estado de la
   navegacion (`lib/razonDelRegistro.js`); el registro pinta con ella su renglon de "crea una cuenta". */
export default function EarnCreditsPage() {
  const { t } = useReadyTranslation(['common', 'dashboard']);
  const { user } = useAuth();

  if (user?.is_guest) {
    return <Navigate to="/signup" replace state={ESTADO_DEL_REBOTE} />;
  }

  return (
    <div className="max-w-[720px] mx-auto flex flex-col gap-6 animate-fade-in-up" data-testid="earn-credits-page">
      <EncabezadoDePagina titulo={t('common:nav.earn_credits')} testid="earn-credits-titulo" />
      <CuadroDeOpinion />
    </div>
  );
}
